import { ZoomFilterViewModel } from './zoom-filter-view-model';
import { ZoomMetaData } from '../../../meta-data/zoom-meta-data';
import { ZoomOperatorViewModelProperty } from '../zoom-operator-view-model-property';
import { ModifiedSubscriberInterface } from '@nts/std/interfaces';

export class InternalZoomFilterViewModel extends ZoomFilterViewModel<any> {

    constructor(metadata: ZoomMetaData, private modifiedSubscriber: ModifiedSubscriberInterface) {
        super(metadata);
        this.operator = new ZoomOperatorViewModelProperty(
            ZoomOperatorViewModelProperty.operatorsForInternal,
            modifiedSubscriber
        );
        this.init();
    }
}
